import type Phaser from 'phaser';
import { safeLocalKv } from '../flow';
import type { KeyValue } from '../../net/progress';
import { AudioManager } from './manager';
import { loadAudioSettings } from './settings';
import { audioState, getAudio, setAudioBackend } from './state';

export type { AudioManifest } from './manager';
export { AudioManager } from './manager';
export { audioState, getAudio, updateAudioSettings } from './state';

/** Crée le gestionnaire audio du jeu, lit les réglages mémorisés et fait sonner les clics de boutons de la couche UI. */
export function installAudio(game: Phaser.Game, uiRoot?: HTMLElement): AudioManager {
  const kv = safeLocalKv();
  const settings = loadAudioSettings(kv);
  audioState.settings.value = settings;
  const manager = new AudioManager(game, settings);
  setAudioBackend(manager, kv);
  uiRoot?.addEventListener('click', (e) => { if ((e.target as Element | null)?.closest?.('button')) getAudio()?.play('ui-click'); });
  return manager;
}

/** Tests : remplace le gestionnaire et le stockage. */
export function _setAudioForTests(m: AudioManager | null, storage: KeyValue | null): void { setAudioBackend(m, storage); }
